import {
  Component, Input, Output, EventEmitter,
  OnChanges, SimpleChanges, AfterViewChecked, ViewChild, ElementRef, signal
} from '@angular/core';

@Component({
  selector: 'app-rich-text-editor',
  standalone: false,
  templateUrl: './rich-text-editor.component.html',
})
export class RichTextEditorComponent implements OnChanges, AfterViewChecked {
  @Input()  value: string = '';
  @Output() valueChange = new EventEmitter<string>();

  @ViewChild('visualEditor') visualEditor!: ElementRef<HTMLDivElement>;

  editorMode = signal<'visual' | 'code'>('visual');

  private needsSync      = false;
  private lastEmitted    = '';  // avoid syncing DOM after our own emission

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      const incoming = changes['value'].currentValue || '';
      // Only sync the DOM when the change came from outside, not from our own valueChange
      if (incoming !== this.lastEmitted) {
        this.needsSync = true;
      }
    }
  }

  ngAfterViewChecked(): void {
    if (this.needsSync && this.visualEditor?.nativeElement && this.editorMode() === 'visual') {
      const el = this.visualEditor.nativeElement;
      if (el.innerHTML !== (this.value || '')) {
        el.innerHTML = this.value || '';
      }
      this.needsSync = false;
    }
  }

  setMode(mode: 'visual' | 'code'): void {
    if (mode === this.editorMode()) return;
    if (this.editorMode() === 'visual' && this.visualEditor?.nativeElement) {
      this.emit(this.visualEditor.nativeElement.innerHTML);
    }
    this.editorMode.set(mode);
    if (mode === 'visual') this.needsSync = true;
  }

  onVisualInput(): void {
    if (this.visualEditor?.nativeElement) {
      this.emit(this.visualEditor.nativeElement.innerHTML);
    }
  }

  onCodeInput(event: Event): void {
    this.emit((event.target as HTMLTextAreaElement).value);
  }

  execFormat(command: string, value: string = ''): void {
    this.visualEditor?.nativeElement?.focus();
    document.execCommand(command, false, value || undefined);
    this.onVisualInput();
  }

  insertHeading(level: 'h2' | 'h3'): void { this.execFormat('formatBlock', level); }
  insertParagraph(): void                   { this.execFormat('formatBlock', 'p'); }
  insertLink(): void {
    const url = prompt('URL du lien :');
    if (url) this.execFormat('createLink', url);
  }

  private emit(val: string): void {
    this.lastEmitted = val;
    this.valueChange.emit(val);
  }
}
